import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "SportsBookContainer" */ './container/SportsBookContainer')
);
